/**
 * Decorative sample invitation used on marketing pages (not a real template).
 * Sizes itself to its container width; text scales with container query units.
 */
export const INVITATION_TONES = {
  ivory: { bg: '#FBF7EE', accent: '#B09536', label: '#8A7322', ink: '#3A3122' },
  midnight: { bg: '#1F2A44', accent: '#D9C27A', label: '#D9C27A', ink: '#F1E7C4' },
  olive: { bg: '#EEF1EA', accent: '#4A6741', label: '#4A6741', ink: '#2F4429' },
  terracotta: { bg: '#F6ECE8', accent: '#8E4A3C', label: '#8E4A3C', ink: '#4A2A22' },
  onyx: { bg: '#1A1A1A', accent: '#C9A94A', label: '#C9A94A', ink: '#EDE3C2' },
  lavender: { bg: '#F3EEF4', accent: '#6A4C7A', label: '#6A4C7A', ink: '#3C2A47' },
};

export const SampleInvitation = ({
  tone = 'ivory',
  kicker = 'שמחת נישואין',
  names = ['שם החתן', 'שם הכלה'],
  showDetails = true,
  double = true,
  className = '',
  style,
}) => {
  const t = INVITATION_TONES[tone] || INVITATION_TONES.ivory;
  // Container queries measure the nearest *ancestor* container, so the
  // wrapper is the container and the card inside sizes its text in cqw.
  return (
    <div className={className} style={{ containerType: 'inline-size', ...style }} aria-hidden="true">
    <div
      className="aspect-[5/7] rounded-[6px] shadow-[0_40px_70px_-28px_rgba(26,26,26,0.5)] p-[7cqw] flex"
      style={{ background: t.bg }}
    >
      <div
        dir="rtl"
        className="flex-1 flex flex-col items-center justify-center gap-[5cqw] text-center font-hebrew"
        style={{
          border: `1px solid ${t.accent}`,
          outline: double ? `1px solid ${t.accent}` : undefined,
          outlineOffset: '-2.5cqw',
          color: t.ink,
        }}
      >
        <div style={{ fontSize: '5cqw', color: t.label }}>בס״ד</div>
        <div style={{ fontSize: '7cqw', color: t.label, letterSpacing: '0.06em' }}>{kicker}</div>
        <div style={{ width: '30cqw', height: 1, background: t.accent }} />
        <div style={{ fontSize: '11cqw', fontWeight: 700, lineHeight: 1.15 }}>
          {names.map((n) => (
            <div key={n}>{n}</div>
          ))}
        </div>
        {showDetails && <div style={{ fontSize: '4.5cqw', opacity: 0.75 }}>[תאריך, מקום]</div>}
      </div>
    </div>
    </div>
  );
};

export default SampleInvitation;
